module.exports = __webpack_public_path__ + "static/media/il_no_events@3x.bf58892c.png";